import React from 'react';

function CrossIcon({ classes = '' }: { classes: string }) {
  return (
    <svg
      data-testid="cross-icon"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M7.96154 10.0385H1.03846C0.744231 10.0385 0.497654 9.93888 0.298731 9.73973C0.0995771 9.54058 0 9.29388 0 8.99965C0 8.70519 0.0995771 8.45862 0.298731 8.25992C0.497654 8.061 0.744231 7.96154 1.03846 7.96154H7.96154V1.03846C7.96154 0.744231 8.06112 0.497654 8.26027 0.298731C8.45942 0.0995771 8.70612 0 9.00035 0C9.29481 0 9.54138 0.0995771 9.74008 0.298731C9.939 0.497654 10.0385 0.744231 10.0385 1.03846V7.96154H16.9615C17.2558 7.96154 17.5023 8.06112 17.7013 8.26027C17.9004 8.45942 18 8.70612 18 9.00035C18 9.29481 17.9004 9.54138 17.7013 9.74008C17.5023 9.939 17.2558 10.0385 16.9615 10.0385H10.0385V16.9615C10.0385 17.2558 9.93888 17.5023 9.73973 17.7013C9.54058 17.9004 9.29388 18 8.99965 18C8.70519 18 8.45862 17.9004 8.25992 17.7013C8.061 17.5023 7.96154 17.2558 7.96154 16.9615V10.0385Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CrossIcon;
